const SEARCH_QUERY_KEY = 'lcq'

export function shouldSubmitLawSearch(value: string): boolean {
  return value.length > 3 || /^§\s*\d+/.test(value.trim())
}

export function useLawSearchQuery() {
  const route = useRoute()
  const searchTerm = ref<string>((route.query[SEARCH_QUERY_KEY] as string) || '')

  watch(() => route.query[SEARCH_QUERY_KEY], (value) => {
    const next = (value as string) || ''
    if (next !== searchTerm.value) {
      searchTerm.value = next
    }
  })

  function writeQuery(value: string | undefined) {
    return navigateTo({ query: { ...route.query, [SEARCH_QUERY_KEY]: value || undefined } })
  }

  // Empty clears the search and returns to the TOC, short non-empty terms keep the current search unchanged. (legacy as-you-type rule).
  const commit = useDebounceFn((value: string) => {
    if (!value.trim()) {
      writeQuery(undefined)
    }
    else if (shouldSubmitLawSearch(value)) {
      writeQuery(value)
    }
  }, 500)

  // Explicit submit (Enter / search button): write the term immediately, bypassing the as-you-type gate.
  function submit(value: string) {
    return writeQuery(value.trim() ? value : undefined)
  }

  function reset() {
    searchTerm.value = ''
    return writeQuery(undefined)
  }

  return { searchTerm, commit, submit, reset }
}
